export default __webpack_public_path__ + "static/media/Group-146-Yono-mitc@2x.08c61e99.png";